import { createRpcMutation } from './factory'

export const useReadNotifications = createRpcMutation({
   fn: 'read_notifications',
   invalidates: () => [['organization-notification']],
})
